<template>
  <svg
    class="animate-spin opacity-25"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="20"
      cy="20"
      r="18"
      fill="none"
      stroke-dashoffset="0"
      stroke-dasharray="75"
      stroke="black"
      stroke-align="inside"
      stroke-width="2"
    />
  </svg>
</template>
